const signalR = require('@microsoft/signalr');

function getConnectionInfo(url, callback) {
    $.ajax({
        type: "POST",
        url: url,
        contentType: "application/json",
        success: function (connectionInfo) {
            callback(connectionInfo);
        }
    });
}

window.InitPaymentStatusCallbackHandler = function (paymentStatusHubUrl) {
    getConnectionInfo(paymentStatusHubUrl, function (info) {
        const options = {
            accessTokenFactory: () => info.accessToken
        };

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(info.url, options)
            .configureLogging(signalR.LogLevel.Error)
            .build();

        connection.start().catch(console.error);

        connection.on('paymentUpdated', (status, provider) => {
            connection.stop().then(r => {
                TryCloseSwishModal();

                switch (status) {
                    case PaymentStatusEnum.COMPLETED:
                        ShowPaymentSuccessCheckbox();
                        return;
                    case PaymentStatusEnum.DECLINED:
                        OpenPaymentDeclinedModal();
                        return;
                    case PaymentStatusEnum.CRASHED:
                        OpenPaymentCrashedModal();
                        return;
                    case PaymentStatusEnum.EXPIRED:
                        OpenPaymentExpiredModal();
                        return;
                    default:
                    //errorUrl += "Payment_Error";
                    //location.href = errorUrl;
                    //return;
                }
            });
        });
    });
}

window.TryCloseSwishModal = function () {
    let modal = document.getElementById("swish-modal");
    if (modal && modal.open) {
        modal.close();
    }
}

window.ShowPaymentSuccessCheckbox = function () {
    let successfulPaymentModal = document.getElementById("successful-payment-modal");
    if (successfulPaymentModal && !successfulPaymentModal.open) {
        successfulPaymentModal.showModal();
    }
}

const PaymentStatusEnum = Object.freeze({
    COMPLETED: "COMPLETED",
    DECLINED: "DECLINED",
    CRASHED: "CRASHED",
    EXPIRED: "EXPIRED",
    ABORTED: "ABORTED",
    STOPPED: "STOPPED"
});
